module.exports = __webpack_public_path__ + "img/flcc2.924458d2.jpg";